import { createContext, useContext, useEffect, useRef, useState } from "react";
import stompClient from "./stompClient";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const [lastMessage, setLastMessage] = useState({
    MessageType: "",
    Message: "No message received yet",
    IDMessage: 0,
  });

  const lastMessageRef = useRef(lastMessage);

  useEffect(() => {
    stompClient.onConnect = () => {
      stompClient.subscribe(
        `/exchange/${window.config.RMQConfig.Exchange}`,
        (message) => {
          const obj = JSON.parse(message.body);

          let setMsg = true;
          if (
            obj.Changes &&
            obj.Changes[0].Field === "MTP" &&
            obj.Changes[0].NewValue === "-128"
          ) {
            setMsg = false;
          }

          if (setMsg) {
            obj.IDMessage = lastMessageRef.current.IDMessage + 1;

            lastMessageRef.current = obj;

            setLastMessage((prevState) =>
              JSON.stringify(prevState) !== JSON.stringify(obj)
                ? { ...obj }
                : prevState,
            );
          }
        },
      );
    };

    stompClient.activate();

    return () => {
      stompClient.deactivate();
    };
  }, []);

  return (
    <WebSocketContext.Provider value={{ lastMessage }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    console.warn("useWebSocket must be used within a WebSocketProvider");
    return {
      lastMessage: { MessageType: "", Message: "No provider detected" },
    };
  }
  return context;
};
